import { Button } from "@/components/ui/button";
import { PAGE_SIZE } from "@/lib/constants";

interface LoadMoreButtonProps {
  hasMore: boolean;
  loading: boolean;
  loadedCount: number;
  totalCount?: number;
  onClick: () => void;
}

export function LoadMoreButton({
  hasMore,
  loading,
  loadedCount,
  totalCount,
  onClick,
}: LoadMoreButtonProps) {
  if (!hasMore) return null;

  return (
    <div className="flex justify-center py-4">
      <Button variant="outline" onClick={onClick} disabled={loading}>
        {loading
          ? "Loading..."
          : `Load ${PAGE_SIZE} more${
              totalCount
                ? ` (showing ${loadedCount} of ${totalCount})`
                : ` (${loadedCount} loaded)`
            }`}
      </Button>
    </div>
  );
}
